import { useRoute, useRouter } from 'vue-router';
import { pushURL } from '@/views/reports/pickers/base/utils';
import { pushURL as pushURLDashboard } from '@/views/dashboard/pickers/base/utils';
import { getDedicatedPushUrlHandler } from '@/views/reports/report-route-push';
import { useTableQuery } from '@/composables/useTableQuery';
import filterService from '@/services/filter';
import { $emitter } from '@/services/emitter';

export const usePickerPushUrl = () => {
  const route = useRoute();
  const router = useRouter();
  const tableQueryApi = useTableQuery();

  const buildContext = () => ({
    $route: route,
    $router: router,
    getTableQueryForCurrentTab: () => tableQueryApi.getTableQueryForCurrentTab(),
    getTableQuerySearch: () => tableQueryApi.getTableQuerySearch(),
    getTableColumnsFiltersForCurrentTabInQueryFormat: () =>
      tableQueryApi.getTableColumnsFiltersForCurrentTabInQueryFormat(),
  });

  const pushReportUrl = (callback?: () => void) => {
    const context = buildContext();

    if (route.name === 'app.index') {
      const onComplete =
        callback ||
        (() => {
          $emitter.emit('refresh-dashboard');
        });
      return pushURLDashboard(context, onComplete);
    }

    const dedicatedPushUrlHandler = getDedicatedPushUrlHandler(route.name);

    if (dedicatedPushUrlHandler) {
      const onComplete =
        callback ||
        (() => {
          if (!filterService.isSet) {
            $emitter.emit('refresh-report');
          }
        });
      return dedicatedPushUrlHandler(context, onComplete);
    }

    const onComplete =
      callback ||
      (() => {
        $emitter.emit('refresh-report');
      });
    return pushURL(context, onComplete);
  };

  return {
    pushReportUrl,
  };
};
